<template>
    <div class="practice-edit mb-3 mt-page">

        <data-form ref="dataForm"
                   title="Edit Practice"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :cancel-route="successRoute"
                   :field-model="practiceFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_PRACTICE_UPDATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_PRACTICE')"
                   :submit-success-route="successRoute">
            <template v-slot:labelSlot="slotProps">
                <emr-lookup-practice-modal v-if="emrReadEnabled"
                                          :fieldModel="slotProps.fieldModel"
                                          :form="slotProps.form"
                                          :company="companyId"/>
                <b-btn v-if="emrWriteEnabled && companyId && !hasEmr"
                       class="btn-secondary ml-2"
                       size="sm"
                       @click="emrCreate()">
                    {{ $i18n.gt('LABEL_EMR_CREATE') }}
                </b-btn>
            </template>
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import PracticeFields from '@/models/Practice'

/**
 * Page for admin to edit a Practice
 */
export default Vue.extend({
    name: "PracticeEdit",
    props: {
        resellerId: Number,
        companyId: Number,
        practiceId: Number,
    },
    data() {
        return {
            practiceFields: PracticeFields,
            fieldGroups: [
                ["name", "npi", "practice_code_id", "emr_id"],
                ["address", "address2", "city", "state", "zip", "email", "website", "phone", "fax"],
                ["type", "comment", "use_dietid_questionnaire", "disabled"],
            ],
            emrReadEnabled: false,
            emrWriteEnabled: false,
            hasEmr: false,
        }
    },
    computed: {
        successRoute() {
            if (this.$user.roleIsAdmin()) {
                return `/practice/admin/companyId/${this.companyId}`
            } else if (this.$user.roleIsResellerAdmin()) {
                return `/practice/resellerAdmin/${this.resellerId}/companyId/${this.companyId}`
            } else {
                return `/practice/companyAdmin/companyId/${this.companyId}`
            }
        },
    },
    mounted() {
        this.$api.emrScope(this, {
            company: this.companyId
        })
            .then((scope) => {
                if (scope) {
                    this.emrReadEnabled = scope.includes('organization.read')
                    this.emrWriteEnabled = scope.includes('organization.write')
                }
            })
    },
    methods: {
        loadModelInstance() {
            return this.$api.getItem(this, 'practice', this.practiceId)
                .then((practice) => {
                    this.hasEmr = practice && !!practice['emr_id']
                    return practice
                })
        },
        onSubmit(modelInstance) {
            return this.$api.updateItem(this, 'practice', modelInstance)
                .then((result) => {
                    if (result && result.ok) {
                        this.$api.emrUpdate(this, 'practice', this.practiceId)
                            .then((result2) => this.$utils.handleEMRError(result))
                    }
                    return result
                })
        },
        async emrCreate() {
            if (await this.$bvModal.msgBoxConfirm(this.$i18n.gt('LABEL_EMR_CONFIRM_CREATE_PRACTICE'))) {
                try {
                    let result = await this.$api.emrUpdate(this, 'practice', this.practiceId)
                    if (result && !this.$utils.handleEMRError(result) && result.id) {
                        if (this.$refs.dataForm && this.$refs.dataForm.form) {
                            this.$refs.dataForm.form.emr_id = result.id
                        }
                    }
                } catch (e) {
                    this.$utils.handleError(e, 'Unable to create EMR record.')
                }
            }
        },
    }
})

</script>

